// src/components/Ouvidoria/OuvidoriaProtocolView.js
import React, { useState } from 'react';
import { db } from '../../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import { FaSearch, FaCommentDots, FaSpinner, FaExclamationCircle } from 'react-icons/fa';

const OuvidoriaProtocolView = ({ userData }) => {
    const [protocolId, setProtocolId] = useState('');
    const [submission, setSubmission] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [searched, setSearched] = useState(false);

    const handleSearch = async (e) => {
        e.preventDefault();
        if (protocolId.trim().length < 5) {
            setError('Por favor, insira um número de protocolo válido.');
            return;
        }

        setIsLoading(true);
        setError('');
        setSubmission(null);
        setSearched(true);

        try {
            const docRef = doc(db, 'Empresas', userData.empresa_id, 'ouvidoria', protocolId);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                setSubmission({ id: docSnap.id, ...docSnap.data() });
            } else {
                setError('Nenhuma manifestação encontrada com este protocolo.');
            }
        } catch (err) {
            console.error("Erro ao buscar protocolo:", err);
            setError('Ocorreu um erro ao buscar sua manifestação. Tente novamente.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="ouvidoria-protocol-view">
            <div className="protocol-search-box">
                <h2><FaSearch /> Consultar Protocolo</h2>
                <p>Insira o código recebido ao enviar sua mensagem para ver o status e as respostas.</p>
                <form onSubmit={handleSearch}>
                    <input
                        type="text"
                        placeholder="Digite seu protocolo aqui..."
                        value={protocolId}
                        onChange={(e) => setProtocolId(e.target.value)}
                        className="form-control"
                    />
                    <button type="submit" className="btn-primary" disabled={isLoading}>
                        {isLoading ? <FaSpinner className="spinner" /> : 'Buscar'}
                    </button>
                </form>
            </div>

            {isLoading && <div className="loading-ouvidoria"><FaSpinner className="spinner" /> Carregando...</div>}
            {error && <p className="error-message">{error}</p>}
            
            {!isLoading && !error && submission && (
                <div className="submission-details-card">
                    <h3>Detalhes da Manifestação</h3>
                    <div className="details-grid">
                        <p><strong>Protocolo:</strong> {submission.id}</p>
                        <p><strong>Data de Envio:</strong> {submission.createdAt ? new Date(submission.createdAt.toDate()).toLocaleString('pt-BR') : '...'}</p>
                        <p><strong>Categoria:</strong> {submission.category}</p>
                        <p><strong>Status:</strong> <span className={`status-badge status-${submission.status}`}>{submission.status.replace('_', ' ')}</span></p>
                    </div>

                    <div className="message-section">
                        <strong>Sua Mensagem Original:</strong>
                        <p className="original-message">{submission.message}</p>
                    </div>

                    <div className="replies-section">
                        <h4><FaCommentDots /> Respostas da Ouvidoria</h4>
                        {submission.replies && submission.replies.length > 0 ? (
                            submission.replies.map((reply, index) => (
                                <div key={index} className="reply-item">
                                    <p>{reply.message}</p>
                                    <small>Respondido em {reply.repliedAt ? new Date(reply.repliedAt.toDate()).toLocaleString('pt-BR') : ''}</small>
                                </div>
                            ))
                        ) : (
                            <div className="no-replies">
                                <FaExclamationCircle />
                                <p>Ainda não há respostas para a sua manifestação. Por favor, verifique novamente mais tarde.</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {!isLoading && searched && !submission && !error && (
                 <div className="empty-state-ouvidoria">
                    <h3>Busca Concluída</h3>
                    <p>Verifique o número do protocolo e tente novamente.</p>
                </div>
            )}
        </div>
    );
};

export default OuvidoriaProtocolView;